import type { TPressureReadingState } from './getPressureReading'
import {
  Z_INDEX_PRESSURE_LIVE,
  Z_INDEX_PRESSURE_NONE,
  Z_INDEX_PRESSURE_RUNNING,
  Z_INDEX_PRESSURE_STALE,
} from './irrigationActivityConstants'

export const getPressureBaseZIndex = ({
  isRunning,
  state,
}: {
  isRunning: boolean
  state: TPressureReadingState
}) => {
  if (state === 'LIVE') return isRunning ? Z_INDEX_PRESSURE_RUNNING : Z_INDEX_PRESSURE_LIVE

  if (state === 'STALE') return Z_INDEX_PRESSURE_STALE

  return Z_INDEX_PRESSURE_NONE
}
